<template>
<section>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <ul class="nav nav-pills">
          <li class="nav-item" v-if="ewbTenant">
            <router-link class="nav-link" active-class="active" to="/admin/ewb-config">Config</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/admin/users">Users</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/admin/credentials">EWaybill Credentials</router-link>
          </li>
          <li class="nav-item" v-if="podTenant">
            <router-link class="nav-link" active-class="active" to="/admin/contact">Contact</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/admin/customers">Customers</router-link>
          </li>
          <li class="nav-item" v-if="ewbTenant">
            <router-link class="nav-link" active-class="active" to="/admin/vendors">Vendors</router-link>
          </li>
          <li class="nav-item" v-if="podTenant">
            <router-link class="nav-link" active-class="active" to="/admin/locations">Warehouses</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/admin/transporters">Transporters</router-link>
          </li>
          <li class="nav-item" v-if="podTenant">
            <router-link class="nav-link" active-class="active" to="/admin/config">Configuration</router-link>
          </li>
          <li class="nav-item" v-if="podTenant">
            <router-link class="nav-link" active-class="active" to="/admin/debug">API Debug</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <router-view></router-view>
</section>
</template>

<script>
export default {
  name: 'AdminPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (this.$store.state.loggedIn) {
        if (!this.$store.state.adminLoggedIn) {
          console.log('Not an Admin')
          this.$router.push('/')
        } else {
          let defPath = this.$route.path
          console.log('Router Path', defPath)
          if (defPath === '/admin') {
            if (this.$store.state.ewbTenent) {
              this.$router.push('/admin/credentials')
            } else {
              this.$router.push('/admin/users')
            }
          } else {
            this.$router.push(defPath)
          }
        }
      } else {
        this.$router.push('/login')
      }
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  computed: {
    ewbTenant () {
      return this.$store.state.ewbTenant
    },
    podTenant () {
      return this.$store.state.podTenant
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminPage.vue